import { render } from "./MetaData.vue?vue&type=template&id=3cc61bda&scoped=true"
import script from "./MetaData.vue?vue&type=script&lang=js"
export * from "./MetaData.vue?vue&type=script&lang=js"

import "./MetaData.vue?vue&type=style&index=0&id=3cc61bda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc61bda"]])

export default __exports__